import { useFormContext } from "react-hook-form";
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ListIcon } from 'lucide-react';
import { DateField } from '@/components/form/fields/DateField';
import { useStatusOptions } from '@/features/alojamientos/hooks/useStatusOptions';
import { useEffect } from 'react';

interface StatusSectionProps {
  mode?: "create" | "edit" | "view";
}

const StatusSection = ({ mode }: StatusSectionProps) => {
  const { setValue, watch } = useFormContext();
  const statusId = watch('statusId');
  const substatusId = watch('substatusId');
  const { statusOptions, substatusOptions } = useStatusOptions(statusId);

  // Determinar si el estado es "Cerrado" (statusId = 2)

  const isStatusClosed = statusId === 2;
  
  useEffect(() => {
    if (!isStatusClosed) {
      setValue('statusUntilDate', null, { shouldValidate: true, shouldDirty: true });
    }
  }, [isStatusClosed, setValue]);

  console.log('statusUntilDate', watch('statusUntilDate'));

  // FIXME: this is weird, why we need to validate this?
  if (mode === "edit" && (statusId === undefined || substatusId === undefined)) {
    console.log('Returning null because mode is edit and values are undefined');
    return null;
  }

  const handleStatusChange = (value: string) => {
    const newStatusId = Number(value);

    // Fixme: quien setea a 0? deberia ser null or undefined
    if (isNaN(newStatusId)) return;

    if (newStatusId === 0) {
      console.warn('❌ Aborting setValue. Invalid statusId:', newStatusId);
      return;
    }

    console.log('handleStatusChange -> Setting statusId to: ', newStatusId);
    setValue('statusId', newStatusId, { shouldValidate: true, shouldDirty: true });
  };

  const handleSubstatusChange = (value: string) => {
    const newSubstatusId = Number(value);
    if (isNaN(newSubstatusId)) return;
    setValue('substatusId', newSubstatusId, { shouldValidate: true, shouldDirty: true });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      <div className="form-group">
        <Label className="form-label flex items-center gap-2">
          <ListIcon size={16} />
          Estado
        </Label>
        <Select 
          value={statusId ? String(statusId) : undefined}
          onValueChange={handleStatusChange}
          >
          <SelectTrigger className="form-select">
            <SelectValue placeholder="Seleccionar estado" />
          </SelectTrigger>
          <SelectContent>
            {statusOptions.map((status) => (
              <SelectItem key={status.id} value={String(status.id)}>
                {status.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="form-group">
        <Label className="form-label flex items-center gap-2">
          <ListIcon size={16} />
          Subestado
        </Label>
        <Select 
          value={substatusId ? String(substatusId) : undefined}
          onValueChange={handleSubstatusChange}
          disabled={!substatusOptions.length}
        >
          <SelectTrigger className="form-select">
            <SelectValue placeholder="Seleccionar subestado" />
          </SelectTrigger>
          <SelectContent>
            {substatusOptions.map((substatus) => (
              <SelectItem key={substatus.id} value={String(substatus.id)}>
                {substatus.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <DateField 
        name="statusDate"
        label="Fecha estado"
        required
        captionLayout="dropdown"
      />

      <DateField 
        name="statusUntilDate"
        label="Cerrado hasta"
        required={isStatusClosed}
        disabled={!isStatusClosed}
        minDate={new Date()}
        captionLayout="dropdown"
      />

      <DateField 
        name="enabledDate"
        label="Fecha de habilitación"
        captionLayout="dropdown"
      />

      <DateField 
        name="lastInspectionDate"
        label="Fecha Última inspección"
        maxDate={new Date()}
        captionLayout="dropdown"
      />
    </div>
  );
};

export default StatusSection;
